import Email from '../../component/inputs/email/index'
import Password from '../../component/inputs/password/index'
import Checkbox from '../../component/inputs/checkbox/index'
import FacebookButton from '../../component/buttons/facebook/index'
import GoogleButton from '../../component/buttons/google/index'
import Dropdown from '../../component/dropdown'
import axios from 'axios'
import '../../../icons'
import Button from '../../component/buttons/button/index'

export default {
  name: 'AccountCreated',
  data () {
      return { backgroundUrl:require('../../../../assets/bg.svg'),
        lang: this.$route.params.lang,
      }



  },
  components: {
    'kw-email': Email,
    'kw-password': Password,
    'kw-checkbox': Checkbox,
    'kw-facebook': FacebookButton,
    'kw-google': GoogleButton,
    'kw-button': Button,
    'dropdown' : Dropdown
  },
  computed: {
  },
  created () {

  },
  methods: {
    redirect () {
      let url = `/${this.lang}`

      window.location.replace(url)
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/views/accountCreated/accountCreated.js